import {Component, OnInit, ViewEncapsulation, ChangeDetectorRef} from '@angular/core';
import {Validators, FormControl} from "@angular/forms";
import {AuthService} from "../../core/auth.service";
import { StateService } from 'app/core/state.service';
import {MatDialog, MatSnackBar} from "@angular/material";
import {
    DeleteEventDialog, NewEventDialog, OverLimitDialogComponent, PopulateNewEventDialog,
    CloseEventDialog
} from './components/dialogs';
import {CheckitEvent, Registrant} from './checkit.model';
import {PaymentService} from "../../payment/payment.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Subject} from "rxjs/Subject";
import {AngularFirestore} from "angularfire2/firestore";
import { firestore } from "firebase"
import {IconedSnackBar} from "./components/snackbars";
import { Observable } from 'rxjs/Observable';


@Component({
    selector: 'checkit-dashboard',
    templateUrl: 'checkit-dashboard.component.html',
    styleUrls: ['checkit-dashboard.component.styl'],
    encapsulation: ViewEncapsulation.None
})
export class CheckitDashboardComponent implements OnInit {

    private $destroy: Subject<boolean> = new Subject();

    public current_event$: Observable<CheckitEvent> = Observable.of(null);
    show_items = true;
    new_event: CheckitEvent;
    existing_event: CheckitEvent;
    credits: number = 0;
    afs: AngularFirestore;
    alert_message = '';

    constructor(
        private auth: AuthService,
        public state: StateService,
        private dialog: MatDialog,
        private payment: PaymentService,
        private route: ActivatedRoute,
        private router: Router,
        private snackbar: MatSnackBar,
        private cd: ChangeDetectorRef
    ) {
        this.afs = auth.afs;
        route.params.takeUntil(this.$destroy).subscribe(params => {
            if(params.hasOwnProperty('eventId')){
                this.state.checkit.page = 'event';
                this.state.checkit.event =  new CheckitEvent(params.eventId);
            }else{
                this.state.checkit.page = 'events';
                this.state.checkit.event = null;
            }
            if (!this.state.accounts['currentId']) return; // user just logged in and events will be set once account is set
            if (params.hasOwnProperty('eventId')) {
                this.show_items = false;
                this.state.setEvent(params.eventId);
            } else {
                this.show_items = true;
                this.state.setEvents();
            }
        });

        this.state.$requests.takeUntil(this.$destroy).subscribe(data => {
            switch (data.request){
                case 'startNewEvent':
                    this.startNewEvent(data.event)
                    break;
                case 'editEvent':
                    this.existing_event = data.editEvent;
                    this.populateExistingEvent();
                    break;
                case 'closeEvent':
                    this.existing_event = data.closeEvent;
                    this.closeEvent();
                    break;
                case 'deleteEvent':
                    this.existing_event = data.event;
                    this.deleteEvent();
                    break;
            }
        });
    }

    ngOnInit() {}

    startNewEvent(starterEvent: CheckitEvent = null) {
        if (this.auth.subscription && (this.state.active_events) >= this.auth.subscription.credits) {
            this.overLimit();
        } else {
            this.new_event = starterEvent || {
                accountId: this.state.accounts['currentId'],
                date: null,
                start: '',
                end: '',
                venue: '',
                address: '',
                venue_url: '',
                totalCheckin: 0,
                inviteSent: 0,
                ticketSent: 0,
                users: [this.state.uid]
            } as CheckitEvent;
            const neDialog = this.dialog.open(NewEventDialog,{
                width: '480px',
                data: { the_event: this.new_event, active: this.state.active_events, credits: this.auth.subscription.credits }
            });

            neDialog.afterClosed().subscribe(data => {
                if (data) {
                    this.new_event = data['the_event'];
                    this.populateNewEvent();
                }
            });
        }
    }

    populateExistingEvent(){
        const neDialog = this.dialog.open(PopulateNewEventDialog,{
            width: '480px',
            data: { the_event: this.existing_event, action: 'update'}
        });

        neDialog.afterClosed().subscribe(data => {
            if (data) {
                const overlimit = this.auth.subscription && (this.state.active_events) >= this.auth.subscription.credits;
                const now = new Date();
                if (overlimit && (this.existing_event['previous_date'] < now) && now < this.existing_event.date) {
                    this.overLimit();
                } else {
                    delete this.existing_event['previous_date'];
                    this.existing_event = data['the_event'] as CheckitEvent;
                    this.existing_event.closed = now > this.existing_event.date;
                    this.afs.doc(`accounts/${this.state.accounts['currentId']}/events/${this.existing_event.eventId}`)
                        .set(this.existing_event, {merge:true});
                }
            }
        });
    }

    populateNewEvent(){
        const neDialog = this.dialog.open(PopulateNewEventDialog, {
            width: '480px',
            data: { the_event: this.new_event, action: 'create'}
        });

        neDialog.afterClosed().subscribe(data => {
            console.log('populate close ',data)
            if (data) {
                let fromEventId = '';
                let toEventId = '';
                const is_duplicate = this.new_event.is_duplicate ? true : false;
                this.new_event = data['the_event'] as CheckitEvent;
                if (is_duplicate) {
                    fromEventId = this.new_event.eventId;
                    toEventId = this.afs.createId();
                    this.new_event.eventId = toEventId;
                    this.new_event.totalCheckin = 0;
                } else {
                    this.new_event.eventId = this.afs.createId();
                }
                this.new_event.created = new Date();
                const nav_to_event = (this.new_event.is_new);
                const retain_unique_ids = this.new_event.retain_unique_ids;
                console.log('retain_unique_ids ',retain_unique_ids)
                delete this.new_event.is_new;
                delete this.new_event.is_duplicate;
                delete this.new_event.retain_unique_ids;
                this.afs.doc(`accounts/${this.state.accounts['currentId']}/events/${this.new_event.eventId}`)
                    .set(this.new_event).then( () => {
                        if (is_duplicate) {
                            this.duplicateRegistrants(fromEventId, toEventId, retain_unique_ids);
                        }
                        this.router.navigate(['checkit-event', this.new_event.eventId]);
                });
            }
        });
    }
    overLimit() {
        this.dialog.open(OverLimitDialogComponent,{width: '480px', data: {credits: this.auth.subscription.credits}})
            .afterClosed().subscribe( data => {
            if (data && data == 'upgrade') {
                this.router.navigate(['my_account', 'manage_subscription']);
            }
        });
    }

    closeEvent(){
        const dialog = this.dialog.open(CloseEventDialog, {width: '480px', data: {evnt: this.existing_event}});
        dialog.afterClosed().subscribe(result => {
            if (result && result.evnt && result.evnt.hasOwnProperty('eventId')) {
                this.afs.doc(`accounts/${this.state.accounts['currentId']}/events/${this.existing_event.eventId}`)
                    .set({closed:true}, {merge:true});
            }
        });
    }

    deleteEvent(){
        const dialog = this.dialog.open(DeleteEventDialog, {width: '480px', data: {evnt: this.existing_event}});
        dialog.afterClosed().subscribe(result => {
            if (result && result.evnt && result.evnt.hasOwnProperty('eventId')) {
                const regRef = this.afs.collection(`accounts/${this.state.accounts['currentId']}/registrants/`);
                regRef.ref.get().then(query => {
                    const batch = this.afs.app.firestore().batch();
                    query.forEach(doc => {
                        const d = doc.data();
                        if (d.eventId == result.evnt.eventId) {
                            batch.delete(doc.ref);
                        }
                    });
                    return batch.commit()
                }).then( x => {
                    const evntId = result.evnt.eventId;
                    const evntRef = this.afs.doc(`accounts/${this.state.accounts['currentId']}/events/${evntId}`);
                    evntRef.delete();
                    this.alert_message = 'Event deleted';
                    setTimeout(() => this.alert_message = '', 5000);
                });
            }
        });
    }


    cancel(){
        this.state.checkit.import = null;
    }

    private duplicateRegistrants(fromEvent: string, toEvent: string, retain_unique_ids: boolean = false) {
        console.log(fromEvent, toEvent, ' retain_unique_ids = ',retain_unique_ids );
        const regRef = this.afs.collection<Registrant>(`accounts/${this.state.accounts['currentId']}/registrants/`,
            ref => { return ref.where("eventId", '==' , fromEvent); });
        const toRef = this.afs.app.firestore().collection(`accounts/${this.state.accounts['currentId']}/registrants/`);
        regRef.valueChanges().subscribe( regs => {
            const batch = this.afs.app.firestore().batch();
            console.log('regs ',regs)
            regs.forEach( reg => {
                const id = this.afs.createId();
                const copied_registrant = {
                    registrantId: id,
                    email: reg.email,
                    firstName: reg.firstName || '',
                    lastName: reg.lastName || '',
                    company: reg.company || '',
                    phone: reg.phone || '',
                    eventId: toEvent,
                    attending: 'pending',
                    walkin: false,
                    method: 'batch_duplicate',
                    created: new Date(),
                    createdBy: this.state.uid,
                    scanId: retain_unique_ids ? reg.scanId : this.afs.createId(),
                    inviteSent: 0,
                    ticketSent: 0,
                    checkedIn: 0,
                    attendingResponse: 0
                } as Registrant;
                batch.set(toRef.doc(id), copied_registrant);
            });
            batch.commit();
        });

    }

    ngOnDestroy(){
        this.$destroy.next();this.$destroy.complete();
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/checkit-dashboard/checkit-dashboard.component.ts